"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ColumnConfig_1 = tslib_1.__importDefault(require("./ColumnConfig"));
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const fmko_ts_common_1 = require("fmko-ts-common");
class StyledColumnConfig extends ColumnConfig_1.default {
    constructor(header, headerStyle, mapDataToField, mapDataToStyle, sortable = false, clickable = false, footer) {
        super(header, headerStyle, mapDataToField, sortable, clickable, footer);
        this.mapDataToStyle = mapDataToStyle;
        this.renderer = {
            canRender: this.canRender,
            render: this.render
        };
    }
    render(ctx, dataAndStyle) {
        const textToRender = (0, fmko_ts_common_1.htmlEncode)(dataAndStyle.data);
        const div = new fmko_ts_widgets_1.HTML(textToRender);
        Object.assign(div.getCssStyle(), dataAndStyle.style);
        ctx.setWidget(div);
    }
    canRender(o) {
        return true;
    }
    getData(data) {
        return { data: this.mapDataToTD(data), style: this.mapDataToStyle(data) };
    }
    getSortableData(data) {
        return this.mapDataToTD(data);
    }
}
exports.default = StyledColumnConfig;
//# sourceMappingURL=StyledColumnConfig.js.map